import React from "react";

const HeaderLanguageIcon = ({ className, fill = "var(--color-primary)" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
			fill={fill}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1 12C1 11.4477 1.44772 11 2 11H22C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H2C1.44772 13 1 12.5523 1 12Z"
			fill={fill}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 1C12.2809 1 12.5489 1.11816 12.7383 1.32558C15.4031 4.24291 16.9175 8.02885 16.9998 11.9792C17.0001 11.9931 17.0001 12.0069 16.9998 12.0208C16.9175 15.9711 15.4031 19.7571 12.7383 22.6744C12.5489 22.8818 12.2809 23 12 23C11.7191 23 11.4511 22.8818 11.2617 22.6744C8.59689 19.7571 7.08251 15.9711 7.00022 12.0208C6.99993 12.0069 6.99993 11.9931 7.00022 11.9792C7.08251 8.02885 8.59689 4.24291 11.2617 1.32558C11.4511 1.11816 11.7191 1 12 1ZM9.00023 12C9.06877 15.0748 10.1263 18.0352 12 20.4492C13.8737 18.0352 14.9312 15.0748 14.9998 12C14.9312 8.92516 13.8737 5.96485 12 3.5508C10.1263 5.96485 9.06877 8.92516 9.00023 12Z"
			fill={fill}
		/>
	</svg>
);

export default HeaderLanguageIcon;
